import { useTheme } from "../contexts/ThemeContext";

export const useGraphTheme = () => {
  const { isDarkMode } = useTheme();

  return {
    theme: isDarkMode ? "dark" : undefined,
    xAxis: {
      label: {
        visible: true,
        autoRotate: true,
        autoHide: true
      },
      title: {
        visible: true
      },
      grid: {
        line: {
          style: {
            lineWidth: 1,
            lineDash: [4, 5],
            strokeOpacity: 0.7
          }
        }
      }
    },
    yAxis: {
      label: {
        visible: true,
        autoRotate: true,
        autoHide: true
      },
      title: {
        visible: true
      },
      grid: {
        line: {
          style: {
            lineWidth: 1,
            lineDash: [4, 5],
            strokeOpacity: 0.7
          }
        }
      }
    },
    legend: {
      position: "top",
      itemName: {
        style: {
          fontSize: 14
        }
      },
      itemValue: {
        style: {
          fontSize: 14
        }
      },
      marker: {
        style: {
          r: 4
        }
      }
    }
  };
};
